import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    checkoutResponse:{},
    error:''
};

export const saveCheckout = createAsyncThunk('checkout/saveCheckout', async (initialObject) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("package_id", initialObject.planId);
    fromData.append("first_name",initialObject.first_name);
    fromData.append("last_name",initialObject.last_name);
    fromData.append("expiry",initialObject.expiry);
    fromData.append("number",initialObject.number);
    fromData.append("cvv",initialObject.cvv);
    fromData.append("accountType",'credit');
    fromData.append("client_id",1);
    fromData.append("cardAlreadyExist",0);
    fromData.append("city",initialObject.city);
    fromData.append("state",initialObject.state);
    fromData.append("zip",initialObject.zip);
    fromData.append("address",initialObject.address);
    fromData.append("Token",accessToken);
    let response = await axios.post('gateways/Authorize_aim/checkout',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}


const CheckoutSlice = createSlice({
    name:'checkout',
    initialState,
    reducers:{
        blankCheckout:(state)=>{
            state.checkoutResponse = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(saveCheckout.fulfilled,(state,action)=>{
            state.checkoutResponse = action.payload
        })
    }
});

export const {blankCheckout} = CheckoutSlice.actions;

export default CheckoutSlice.reducer;
